import api from './api';

export const validateCoupon = async (code, totalAmount) => {
  const response = await api.post('/coupons/validate', { code, totalAmount });
  return response.data;
};

